import { alpha } from '@mui/material';

import styled from 'features/theme/styled';
import theme from 'features/theme/theme';

export const DialPadButtonBase = styled('button')<{
  $flex?: string | number;
  $width?: string;
  $margin?: string;
}>`
  background: #404448;
  color: ${alpha(theme.palette.common.white, 0.7)};
  border: none;
  cursor: pointer;
  font-family: Inter;
  font-size: 19px;
  font-style: normal;
  font-weight: 500;
  line-height: 30px;
  transition: all 0.2s ease;
  padding: ${theme.spacing(6)};
  border-radius: 10px;
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;

  /* layout props */
  flex: ${({ $flex }) => $flex || 'initial'};
  width: ${({ $width }) => $width || 'auto'};
  margin: ${({ $margin }) => $margin || '0'};

  &:hover {
    color: ${theme.palette.common.white};
    background-color: ${alpha(theme.palette.grey[800], 0.9)};
  }

  &:active {
    background-color: ${alpha(theme.palette.grey[700], 0.9)};
  }
`;
